export const smbOnboarding2 = {
  title: "Üzleti oldal létrehozása",
  subtitle: "Töltsd ki az alábbi lépéseket, hogy az AI felépíthesse az oldaladat",
  navigation: {
    back: "Vissza",
    next: "Tovább",
    finish: "Befejezés",
    step: "Lépés",
    of: "/",
  },
  toast: {
    name_required: "Név kötelező",
    name_required_desc: "Kérjük, add meg az üzleted nevét a folytatás előtt.",
    saved: "Sikeres mentés!",
    saved_desc: "Az onboarding adatokat sikeresen elküldtük. Az AI hamarosan elkészíti az oldaladat.",
    error: "Hiba",
    error_desc: "Hiba történt a mentés közben. Kérjük, próbáld újra.",
  },
  steps: {
    business_info: {
      title: "Üzleti alapadatok",
      description: "Add meg a vállalkozásod alapvető információit.",
      business_name: "Vállalkozás neve",
      business_name_placeholder: "pl. Szép Frizura Fodrászat",
      business_category: "Kategória",
      business_category_placeholder: "Válaszd ki a kategóriát",
      bio: "Rövid leírás",
      bio_placeholder: "Mesélj a vállalkozásodról, mit csinálsz, mi tesz különlegessé...",
      logo: "Logó",
      upload_logo: "Logó feltöltése",
      logo_help: "Kattints a feltöltéshez (min. 500x500px ajánlott)",
      address: "Cím",
      address_placeholder: "1234 Budapest, Példa utca 12.",
      phone: "Telefonszám",
      phone_placeholder: "+36 20 123 4567",
      email: "E-mail cím",
      email_placeholder: "info@uzletem.hu",
      categories: {
        salon: "Fodrászat",
        barbershop: "Borbélyszalon",
        beauty_salon: "Szépségszalon",
        nail_salon: "Körömsalon",
        spa: "Spa / Wellness",
        massage: "Masszázs",
        yoga_studio: "Yoga stúdió",
        fitness_center: "Fitnesz központ",
        pilates_studio: "Pilates stúdió",
        dance_studio: "Tánc stúdió",
        personal_training: "Személyi edzés",
        nutritionist: "Táplálkozási tanácsadás",
        physiotherapy: "Fizikoterápia",
        dental: "Fogorvosi rendelő",
        veterinary: "Állatorvosi rendelő",
        cafe: "Kávézó",
        restaurant: "Étterem",
        bakery: "Pékség",
        photography: "Fotóstúdió",
        tutoring: "Magánoktatás",
        music_school: "Zeneiskola",
        art_studio: "Művészeti stúdió",
        consulting: "Tanácsadás",
        accounting: "Könyvelés",
        legal: "Jogi szolgáltatás",
        real_estate: "Ingatlan",
        cleaning: "Takarítás",
        repair: "Javítás / szerelés",
        pet_grooming: "Állatkozmetika",
        other: "Egyéb",
      },
      tip_title: "Tipp",
      tip_description: "Az alapvető információk segítenek az ügyfeleidnek megtalálni téged. Ügyelj arra, hogy pontos és naprakész legyen minden adat.",
    },
    services: {
      title: "Szolgáltatások",
      description: "Add meg, milyen szolgáltatásokat kínálsz az ügyfeleidnek.",
      add_service: "Szolgáltatás hozzáadása",
      service_name: "Szolgáltatás neve",
      service_name_placeholder: "pl. Női hajvágás",
      service_description: "Leírás",
      service_description_placeholder: "Rövid leírás a szolgáltatásról",
      service_price: "Ár (Ft)",
      service_price_placeholder: "5000",
      service_duration: "Időtartam (perc)",
      service_duration_placeholder: "60",
      no_services: "Még nincs szolgáltatás hozzáadva",
      services_added: "szolgáltatás hozzáadva",
      remove_service: "Törlés",
      tip_title: "Tipp",
      tip_description: "Adj meg világos árakat és időtartamokat. Ez segít az ügyfeleidnek dönteni és időpontot foglalni.",
    },
    opening_hours: {
      title: "Nyitvatartás",
      description: "Add meg az üzleted nyitvatartási idejét.",
      day_closed: "Zárva",
      day_open: "Nyitva",
      from: "Mettől",
      to: "Meddig",
      days: {
        monday: "Hétfő",
        tuesday: "Kedd",
        wednesday: "Szerda",
        thursday: "Csütörtök",
        friday: "Péntek",
        saturday: "Szombat",
        sunday: "Vasárnap",
      },
      tip_title: "Tipp",
      tip_description: "Pontos nyitvatartási idő segít az ügyfeleidnek tervezni.",
    },
    team: {
      title: "Csapat (opcionális)",
      description: "Add meg a csapattagjaid, akik az üzletedben dolgoznak.",
      add_member: "Csapattag hozzáadása",
      member_name: "Név",
      member_name_placeholder: "pl. Kiss Anna",
      member_role: "Pozíció",
      member_role_placeholder: "pl. Fodrász",
      member_photo: "Fotó",
      upload_photo: "Fotó feltöltése",
      no_members: "Még nincs csapattag hozzáadva",
      members_added: "csapattag hozzáadva",
      remove_member: "Törlés",
      tip_title: "Tipp",
      tip_description: "A csapat bemutatása személyesebbé teszi az üzletedet. Ez a lépés opcionális.",
    },
    target_audience: {
      title: "Célközönség",
      description: "Határozd meg, kiknek szólnak a szolgáltatásaid.",
      age_groups: "Korosztályok",
      age_group_options: {
        teens: "Tizenévesek (13-17)",
        young_adults: "Fiatal felnőttek (18-25)",
        adults: "Felnőttek (26-40)",
        middle_aged: "Középkorúak (41-60)",
        seniors: "Idősek (60+)",
      },
      communication_style: "Kommunikációs stílus",
      communication_style_placeholder: "pl. Barátságos, közvetlen, szakértő",
      communication_styles: {
        friendly: "Barátságos",
        professional: "Professzionális",
        casual: "Laza, közvetlen",
        expert: "Szakértő",
        motivating: "Motiváló",
      },
      keywords: "Kulcsszavak",
      keywords_placeholder: "pl. minőség, megbízhatóság, személyre szabott",
      add_keyword: "Kulcsszó hozzáadása",
      tip_title: "Tipp",
      tip_description: "A célközönség ismerete segít az AI-nak személyre szabott tartalmat és kommunikációt generálni az oldaladra.",
    },
    social_media: {
      title: "Közösségi média",
      description: "Add meg a közösségi média fiókjaid linkjeit.",
      instagram: "Instagram",
      instagram_placeholder: "https://instagram.com/felhasznalonev",
      facebook: "Facebook",
      facebook_placeholder: "https://facebook.com/oldalnev",
      tiktok: "TikTok",
      tiktok_placeholder: "https://tiktok.com/@felhasznalonev",
      youtube: "YouTube",
      youtube_placeholder: "https://youtube.com/@csatornanev",
      linkedin: "LinkedIn",
      linkedin_placeholder: "https://linkedin.com/in/felhasznalonev",
      x: "X (Twitter)",
      x_placeholder: "https://x.com/felhasznalonev",
      tip_title: "Tipp",
      tip_description: "A közösségi média linkek segítenek az oldalad látogatóinak megtalálni téged más platformokon is.",
    },
    digital_products: {
      title: "Digitális termékek",
      description: "Milyen digitális termékeket szeretnél árulni az oldaladon?",
      select_types: "Válaszd ki a típusokat",
      types: {
        ebook: "E-book",
        video_course: "Videókurzus",
        template: "Sablon / Template",
        audio: "Hanganyag / Podcast",
        worksheet: "Munkafüzet / Feladatlap",
        recipe: "Recept gyűjtemény",
        guide: "Útmutató / Guide",
        checklist: "Ellenőrző lista",
        meal_plan: "Étrend / Étkezési terv",
        training_plan: "Edzésterv",
        printable: "Nyomtatható anyag",
        other: "Egyéb",
      },
      description_label: "Megjegyzés a digitális termékekhez",
      description_placeholder: "Írd le röviden, milyen digitális termékeket tervezel...",
      no_selection: "Még nem választottál típust",
      tip_title: "Tipp",
      tip_description: "A digitális termékek passzív bevételi forrást biztosítanak. Az AI az itt megadott típusok alapján alakítja ki az oldaladat.",
    },
    design: {
      title: "Megjelenés, arculat",
      description: "Válaszd ki, milyen megjelenési stílust szeretnél az oldaladon.",
      style_label: "Design stílus",
      styles: {
        modern: "Modern & Minimalista",
        elegant: "Elegáns & Luxus",
        playful: "Játékos & Színes",
        professional: "Professzionális & Üzleti",
        natural: "Természetes & Organikus",
        bold: "Merész & Feltűnő",
      },
      color_label: "Fő szín",
      colors: {
        blue: "Kék",
        purple: "Lila",
        pink: "Rózsaszín",
        red: "Piros",
        orange: "Narancs",
        yellow: "Sárga",
        green: "Zöld",
        teal: "Türkiz",
        gray: "Szürke",
        black: "Fekete",
      },
      font_label: "Betűtípus stílus",
      fonts: {
        modern: "Modern (Manrope)",
        classic: "Klasszikus (Merriweather)",
        elegant: "Elegáns (Playfair Display)",
        clean: "Letisztult (Inter)",
        creative: "Kreatív (Comfortaa)",
      },
      theme_label: "Téma mód",
      themes: {
        light: "Világos",
        dark: "Sötét",
        auto: "Automatikus",
      },
      references_label: "Inspiráció / Referencia",
      references_placeholder: "Van olyan weboldal vagy stílus, ami tetszik? Írd le vagy adj meg linkeket...",
      tip_title: "Profi tipp",
      tip_description: "A jó design növeli a bizalmat. Válassz olyan stílust, ami tükrözi az üzleted személyiségét.",
    },
  },
};
